
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pedagogie",
      function () {
        return require("private-next-pages/pedagogie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pedagogie"])
      });
    }
  